
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index3MZ1iPOfjIEBSQ47hSk4ZC_dSIHItaMjzYQtj01EIrIMeta } from "/builds/the-eastern-polygon/web/pages/index.vue?macro=true";
import { default as policy7x15Ue5gFwbjbeKUQfOYl_45Jzc1EYWewMrU8EX20VlOsMeta } from "/builds/the-eastern-polygon/web/pages/policy.vue?macro=true";
import { default as privacyB7feScZkN6suQjutIuoZCKskTr6Fx88AdqPTU2ijSpcMeta } from "/builds/the-eastern-polygon/web/pages/privacy.vue?macro=true";
import { default as support270PE784SmbYH9pS8NfEMNmvL4YQdvgXRXvNYPnVjhQMeta } from "/builds/the-eastern-polygon/web/pages/support.vue?macro=true";
import { default as mapGs758qd9rUD5lmHf2ZQl7oHYlpLdZRTnI3hDSvG68WkMeta } from "/builds/the-eastern-polygon/web/pages/_bam/map.vue?macro=true";
import { default as mapYH2NIpLqbRhLnbF1gjpY4pkD88KkEglQK4eGRpjeENQMeta } from "/builds/the-eastern-polygon/web/pages/_mtk/map.vue?macro=true";
import { default as mapLloxp4_45tJUGCz0U3qMKGG9tBWTH6uhj3IwQ8bB6QXg0Meta } from "/builds/the-eastern-polygon/web/pages/_vsm/map.vue?macro=true";
import { default as _91unique_93OEqviVGEmhzXMloSYGVNqlel4GyfLSK3enkunJ6xd8QMeta } from "/builds/the-eastern-polygon/web/pages/[category]/[unique].vue?macro=true";
import { default as mapjS_45FgdTc_45wkYMXOrbF9MmiEsFReGDEnR_dSbuqv5EY4Meta } from "/builds/the-eastern-polygon/web/pages/_eastern-polygon/map.vue?macro=true";
import { default as _91id_93h_45xNq8yxsGSoopdjBI5hUCwknszz_45IyahD4sfTWPyKkMeta } from "/builds/the-eastern-polygon/web/pages/[category]/photo/[id].vue?macro=true";
import { default as _91id_935T4pjqdYZvZwa6ut9sEGyJ0XLgaRljUJZP_9GZspSRgMeta } from "/builds/the-eastern-polygon/web/pages/[category]/video/[id].vue?macro=true";
import { default as indexUUDo3_cipnVjci2NwhNPY7Mqq6Dvqohk_45RC_HtwgAnUMeta } from "/builds/the-eastern-polygon/web/pages/[category]/atlas/index.vue?macro=true";
import { default as indexfZzysPEanNSVE3GDyIqQTO_45DfQP9hZyi2vFnUfdNyQMMeta } from "/builds/the-eastern-polygon/web/pages/[category]/photo/index.vue?macro=true";
import { default as indexhAA6gtXPB2rm3qAUFBl_1eDEd6sm7a92OwPp90vh5nwMeta } from "/builds/the-eastern-polygon/web/pages/[category]/video/index.vue?macro=true";
import { default as firstK6UDBs98jar0M96iRyKlIvX25kiP2lwJgG0O8e4Ta2EMeta } from "/builds/the-eastern-polygon/web/pages/[category]/periods/first.vue?macro=true";
import { default as thirdrQsAjp6si0_FZxsuqenkj_Y9ihh0HaDieFrD_F3CSkIMeta } from "/builds/the-eastern-polygon/web/pages/[category]/periods/third.vue?macro=true";
import { default as second6KkC_45yGe8mzirCEETit1CJh_WlKeEaA_45OWyuyDhEdssMeta } from "/builds/the-eastern-polygon/web/pages/[category]/periods/second.vue?macro=true";
import { default as vacanciesWbBqJodWanSf4UP_mdrlhNHcaQrK_F3_CwVhTu8g1PUMeta } from "/builds/the-eastern-polygon/web/pages/_eastern-polygon/vacancies.vue?macro=true";
import { default as _91slug_93KRzrFg89orjkFsKPo_45NUu0rLglNKhMfO__45Ng4_Q8mrUMeta } from "/builds/the-eastern-polygon/web/pages/[category]/longread/[slug].vue?macro=true";
import { default as mapDd21_45rFJ1J_45_nBOy9a_450Y1GT8co4L7TPuMcF6Nao5YMMeta } from "/builds/the-eastern-polygon/web/pages/_trans-siberian-railway/map.vue?macro=true";
import { default as klimat_45rossiinJbKOworP_7Ecf_eM4DjnzM_45MvPsLUQR7xi2H1NNIFQMeta } from "/builds/the-eastern-polygon/web/pages/[category]/atlas/klimat-rossii.vue?macro=true";
import { default as index53dleJC51Xijh_ePIRpx6VCDtH6nHs5kW7iOUy00CLIMeta } from "/builds/the-eastern-polygon/web/pages/[category]/cards-[cards]/index.vue?macro=true";
import { default as infrastructuret_f5BxTCOLTTnkJjuiY8ey_45QDpYfx09Nvflx7psY_4588Meta } from "/builds/the-eastern-polygon/web/pages/_eastern-polygon/infrastructure.vue?macro=true";
import { default as _91slug_93NbnCSiqVWDq6hxZ6H_b9g3vk8B4QUpa6hr5OojHsC6QMeta } from "/builds/the-eastern-polygon/web/pages/[category]/cards-[cards]/[slug].vue?macro=true";
import { default as elektrifikaciyaWA9Bs_BwAFBgQfTPbjLxzIHvWAVz4yo4Zyw5Iqj1_45o4Meta } from "/builds/the-eastern-polygon/web/pages/[category]/atlas/elektrifikaciya.vue?macro=true";
import { default as elektroenergetikaI6J5IcQho7KXbLhxLDBhBXNIRXDCDpo2dZK5Dkde_HgMeta } from "/builds/the-eastern-polygon/web/pages/[category]/atlas/elektroenergetika.vue?macro=true";
import { default as podgotovka_45kadrovQE_DYJm_45ozIviYhl_1bw_45M9Sekobj9rtr4dZy6vX8b4Meta } from "/builds/the-eastern-polygon/web/pages/[category]/atlas/podgotovka-kadrov.vue?macro=true";
import { default as zheleznaya_45dorogaGErYqwrsuilqXtmRgcHQbVosyXQvO79CcrvbzLJgxsIMeta } from "/builds/the-eastern-polygon/web/pages/[category]/atlas/zheleznaya-doroga.vue?macro=true";
import { default as mineralnye_45resursy4BzFGQMZoLTAv1gp2uQ21TbZvwXsmjpuBlkSukp5QAIMeta } from "/builds/the-eastern-polygon/web/pages/[category]/atlas/mineralnye-resursy.vue?macro=true";
import { default as putevoe_45hozyajstvog29nIQXlt9ydMmjg_45Nm9hyVC31nTil7bOrLkV1NK_G8Meta } from "/builds/the-eastern-polygon/web/pages/[category]/atlas/putevoe-hozyajstvo.vue?macro=true";
import { default as index10DCcpIGLWsjfVnDcea7pUM9KgBs4mKXxaMoInu8GIcMeta } from "/builds/the-eastern-polygon/web/pages/[category]/longreads/[parent]/index.vue?macro=true";
import { default as poligonnyh_45principyTVzFoR2sSS9I72EeftAzt_uPMXYOgbm23m9toqILx7wMeta } from "/builds/the-eastern-polygon/web/pages/[category]/atlas/poligonnyh-principy.vue?macro=true";
import { default as istoricheskoe_45nasledie6SNHM937jDaWPkLU03eHY4CNgH1yeFEv7dGH_45LEjrSUMeta } from "/builds/the-eastern-polygon/web/pages/[category]/atlas/istoricheskoe-nasledie.vue?macro=true";
import { default as proizvodstvo_45produkciiMawJzb_0vbofOQcjuMhrodGo85spBDyRtnqJyKVenAwMeta } from "/builds/the-eastern-polygon/web/pages/[category]/atlas/proizvodstvo-produkcii.vue?macro=true";
import { default as snezhnyj_45pokrov_45meteliXkL5kDnGj2hfNxlGvf_45IAUzbC8Lr8PPmUbLgJr7lVIkMeta } from "/builds/the-eastern-polygon/web/pages/[category]/atlas/snezhnyj-pokrov-meteli.vue?macro=true";
import { default as snezhnyj_45pokrov_45visotaZkVY1BTfKA2U6Yi6MmxTpAu_xWp4ijDPbTtexb4g59gMeta } from "/builds/the-eastern-polygon/web/pages/[category]/atlas/snezhnyj-pokrov-visota.vue?macro=true";
import { default as toplivno_45energ_45resursy5FZXJX8IBuAwCxYtVTR8jxv8_PTPgbDTD6TJz5JzoD8Meta } from "/builds/the-eastern-polygon/web/pages/[category]/atlas/toplivno-energ-resursy.vue?macro=true";
import { default as passazhirskie_45perevozkioAKUUKGDhxHAw_455MsPrilRyMVxOL9LEx30jJ710NgTsMeta } from "/builds/the-eastern-polygon/web/pages/[category]/atlas/passazhirskie-perevozki.vue?macro=true";
import { default as temperatury_45sred_45menee8H9XAqV61wJNwhRP_45s9fFY0xef42KmzlrIMMx7BbO8mQMeta } from "/builds/the-eastern-polygon/web/pages/[category]/atlas/temperatury-sred-menee8.vue?macro=true";
import { default as temperatury_45sred_45vozduha552KlBaLcIqatoZechoAtIAo6gOdKQcgfh0s7qCQZ1QMeta } from "/builds/the-eastern-polygon/web/pages/[category]/atlas/temperatury-sred-vozduha.vue?macro=true";
import { default as snezhnyj_45pokrov_45otlojeniaYY1DDfQZrppPWP8uebHLIm1mjpiiZ03FOvEWEy2C5_450Meta } from "/builds/the-eastern-polygon/web/pages/[category]/atlas/snezhnyj-pokrov-otlojenia.vue?macro=true";
import { default as snezhnyj_45pokrov_45chislo_45dnei84lM84UByzD99_yhpRWXO5o6JZy_45Q63tUZZE8yC0Jo4Meta } from "/builds/the-eastern-polygon/web/pages/[category]/atlas/snezhnyj-pokrov-chislo-dnei.vue?macro=true";
import { default as temperatury_45max_45sred_45vozduhaH6jRF9MDgKwuTaAxzv5aBBorfnc29jwAwpxHof0CZBoMeta } from "/builds/the-eastern-polygon/web/pages/[category]/atlas/temperatury-max-sred-vozduha.vue?macro=true";
import { default as temperatury_45min_45sred_45vozduhaVXBwPvZtCc9_45yFgPolaNdUg_45Q30QF5bAi0co6mnFr28Meta } from "/builds/the-eastern-polygon/web/pages/[category]/atlas/temperatury-min-sred-vozduha.vue?macro=true";
import { default as indexBSYMnOReH6tYcOaDTOhiMKD18tQrtckhQX_P0S_NnhIMeta } from "/builds/the-eastern-polygon/web/pages/[category]/longreads/[parent]/[parent2]/index.vue?macro=true";
import { default as longread_45_91slug_93D9YVlCzWuSv6NaXhlg_ZHTWotgh0gs5Vg1Lkjv6FsSEMeta } from "/builds/the-eastern-polygon/web/pages/[category]/longreads/[parent]/longread-[slug].vue?macro=true";
import { default as longread_45vokzaly9GMI9uHzf_45JSASw16_450VOh5uf622x1OiuoTBwpJUVe8Meta } from "/builds/the-eastern-polygon/web/pages/[category]/longreads/[parent]/longread-vokzaly.vue?macro=true";
import { default as prigorodnoe_45passazh_45soobshchenieCYTYJipT58DB1kf1RVxY3vK2o23FOFOFmSxsqmsW9c8Meta } from "/builds/the-eastern-polygon/web/pages/[category]/atlas/prigorodnoe-passazh-soobshchenie.vue?macro=true";
import { default as longread_45_91slug_93JGzd9sNl1dZsWK0is5extDRH7GHICu1P9_o6ni5rDvkMeta } from "/builds/the-eastern-polygon/web/pages/[category]/longreads/[parent]/[parent2]/longread-[slug].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/builds/the-eastern-polygon/web/pages/index.vue")
  },
  {
    name: "policy",
    path: "/policy",
    component: () => import("/builds/the-eastern-polygon/web/pages/policy.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    component: () => import("/builds/the-eastern-polygon/web/pages/privacy.vue")
  },
  {
    name: "support",
    path: "/support",
    component: () => import("/builds/the-eastern-polygon/web/pages/support.vue")
  },
  {
    name: "_bam-map",
    path: "/_bam/map",
    component: () => import("/builds/the-eastern-polygon/web/pages/_bam/map.vue")
  },
  {
    name: "_mtk-map",
    path: "/_mtk/map",
    component: () => import("/builds/the-eastern-polygon/web/pages/_mtk/map.vue")
  },
  {
    name: "_vsm-map",
    path: "/_vsm/map",
    component: () => import("/builds/the-eastern-polygon/web/pages/_vsm/map.vue")
  },
  {
    name: "category-unique",
    path: "/:category()/:unique()",
    component: () => import("/builds/the-eastern-polygon/web/pages/[category]/[unique].vue")
  },
  {
    name: "_eastern-polygon-map",
    path: "/_eastern-polygon/map",
    component: () => import("/builds/the-eastern-polygon/web/pages/_eastern-polygon/map.vue")
  },
  {
    name: "category-photo-id",
    path: "/:category()/photo/:id()",
    component: () => import("/builds/the-eastern-polygon/web/pages/[category]/photo/[id].vue")
  },
  {
    name: "category-video-id",
    path: "/:category()/video/:id()",
    component: () => import("/builds/the-eastern-polygon/web/pages/[category]/video/[id].vue")
  },
  {
    name: "category-atlas",
    path: "/:category()/atlas",
    meta: indexUUDo3_cipnVjci2NwhNPY7Mqq6Dvqohk_45RC_HtwgAnUMeta || {},
    component: () => import("/builds/the-eastern-polygon/web/pages/[category]/atlas/index.vue")
  },
  {
    name: "category-photo",
    path: "/:category()/photo",
    component: () => import("/builds/the-eastern-polygon/web/pages/[category]/photo/index.vue")
  },
  {
    name: "category-video",
    path: "/:category()/video",
    component: () => import("/builds/the-eastern-polygon/web/pages/[category]/video/index.vue")
  },
  {
    name: "category-periods-first",
    path: "/:category()/periods/first",
    component: () => import("/builds/the-eastern-polygon/web/pages/[category]/periods/first.vue")
  },
  {
    name: "category-periods-third",
    path: "/:category()/periods/third",
    component: () => import("/builds/the-eastern-polygon/web/pages/[category]/periods/third.vue")
  },
  {
    name: "category-periods-second",
    path: "/:category()/periods/second",
    component: () => import("/builds/the-eastern-polygon/web/pages/[category]/periods/second.vue")
  },
  {
    name: "_eastern-polygon-vacancies",
    path: "/_eastern-polygon/vacancies",
    component: () => import("/builds/the-eastern-polygon/web/pages/_eastern-polygon/vacancies.vue")
  },
  {
    name: "category-longread-slug",
    path: "/:category()/longread/:slug()",
    component: () => import("/builds/the-eastern-polygon/web/pages/[category]/longread/[slug].vue")
  },
  {
    name: "_trans-siberian-railway-map",
    path: "/_trans-siberian-railway/map",
    component: () => import("/builds/the-eastern-polygon/web/pages/_trans-siberian-railway/map.vue")
  },
  {
    name: "category-atlas-klimat-rossii",
    path: "/:category()/atlas/klimat-rossii",
    meta: klimat_45rossiinJbKOworP_7Ecf_eM4DjnzM_45MvPsLUQR7xi2H1NNIFQMeta || {},
    component: () => import("/builds/the-eastern-polygon/web/pages/[category]/atlas/klimat-rossii.vue")
  },
  {
    name: "category-cards-cards",
    path: "/:category()/cards-:cards()",
    component: () => import("/builds/the-eastern-polygon/web/pages/[category]/cards-[cards]/index.vue")
  },
  {
    name: "_eastern-polygon-infrastructure",
    path: "/_eastern-polygon/infrastructure",
    component: () => import("/builds/the-eastern-polygon/web/pages/_eastern-polygon/infrastructure.vue")
  },
  {
    name: "category-cards-cards-slug",
    path: "/:category()/cards-:cards()/:slug()",
    component: () => import("/builds/the-eastern-polygon/web/pages/[category]/cards-[cards]/[slug].vue")
  },
  {
    name: "category-atlas-elektrifikaciya",
    path: "/:category()/atlas/elektrifikaciya",
    meta: elektrifikaciyaWA9Bs_BwAFBgQfTPbjLxzIHvWAVz4yo4Zyw5Iqj1_45o4Meta || {},
    component: () => import("/builds/the-eastern-polygon/web/pages/[category]/atlas/elektrifikaciya.vue")
  },
  {
    name: "category-atlas-elektroenergetika",
    path: "/:category()/atlas/elektroenergetika",
    meta: elektroenergetikaI6J5IcQho7KXbLhxLDBhBXNIRXDCDpo2dZK5Dkde_HgMeta || {},
    component: () => import("/builds/the-eastern-polygon/web/pages/[category]/atlas/elektroenergetika.vue")
  },
  {
    name: "category-atlas-podgotovka-kadrov",
    path: "/:category()/atlas/podgotovka-kadrov",
    meta: podgotovka_45kadrovQE_DYJm_45ozIviYhl_1bw_45M9Sekobj9rtr4dZy6vX8b4Meta || {},
    component: () => import("/builds/the-eastern-polygon/web/pages/[category]/atlas/podgotovka-kadrov.vue")
  },
  {
    name: "category-atlas-zheleznaya-doroga",
    path: "/:category()/atlas/zheleznaya-doroga",
    meta: zheleznaya_45dorogaGErYqwrsuilqXtmRgcHQbVosyXQvO79CcrvbzLJgxsIMeta || {},
    component: () => import("/builds/the-eastern-polygon/web/pages/[category]/atlas/zheleznaya-doroga.vue")
  },
  {
    name: "category-atlas-mineralnye-resursy",
    path: "/:category()/atlas/mineralnye-resursy",
    meta: mineralnye_45resursy4BzFGQMZoLTAv1gp2uQ21TbZvwXsmjpuBlkSukp5QAIMeta || {},
    component: () => import("/builds/the-eastern-polygon/web/pages/[category]/atlas/mineralnye-resursy.vue")
  },
  {
    name: "category-atlas-putevoe-hozyajstvo",
    path: "/:category()/atlas/putevoe-hozyajstvo",
    meta: putevoe_45hozyajstvog29nIQXlt9ydMmjg_45Nm9hyVC31nTil7bOrLkV1NK_G8Meta || {},
    component: () => import("/builds/the-eastern-polygon/web/pages/[category]/atlas/putevoe-hozyajstvo.vue")
  },
  {
    name: "category-longreads-parent",
    path: "/:category()/longreads/:parent()",
    component: () => import("/builds/the-eastern-polygon/web/pages/[category]/longreads/[parent]/index.vue")
  },
  {
    name: "category-atlas-poligonnyh-principy",
    path: "/:category()/atlas/poligonnyh-principy",
    meta: poligonnyh_45principyTVzFoR2sSS9I72EeftAzt_uPMXYOgbm23m9toqILx7wMeta || {},
    component: () => import("/builds/the-eastern-polygon/web/pages/[category]/atlas/poligonnyh-principy.vue")
  },
  {
    name: "category-atlas-istoricheskoe-nasledie",
    path: "/:category()/atlas/istoricheskoe-nasledie",
    meta: istoricheskoe_45nasledie6SNHM937jDaWPkLU03eHY4CNgH1yeFEv7dGH_45LEjrSUMeta || {},
    component: () => import("/builds/the-eastern-polygon/web/pages/[category]/atlas/istoricheskoe-nasledie.vue")
  },
  {
    name: "category-atlas-proizvodstvo-produkcii",
    path: "/:category()/atlas/proizvodstvo-produkcii",
    meta: proizvodstvo_45produkciiMawJzb_0vbofOQcjuMhrodGo85spBDyRtnqJyKVenAwMeta || {},
    component: () => import("/builds/the-eastern-polygon/web/pages/[category]/atlas/proizvodstvo-produkcii.vue")
  },
  {
    name: "category-atlas-snezhnyj-pokrov-meteli",
    path: "/:category()/atlas/snezhnyj-pokrov-meteli",
    meta: snezhnyj_45pokrov_45meteliXkL5kDnGj2hfNxlGvf_45IAUzbC8Lr8PPmUbLgJr7lVIkMeta || {},
    component: () => import("/builds/the-eastern-polygon/web/pages/[category]/atlas/snezhnyj-pokrov-meteli.vue")
  },
  {
    name: "category-atlas-snezhnyj-pokrov-visota",
    path: "/:category()/atlas/snezhnyj-pokrov-visota",
    meta: snezhnyj_45pokrov_45visotaZkVY1BTfKA2U6Yi6MmxTpAu_xWp4ijDPbTtexb4g59gMeta || {},
    component: () => import("/builds/the-eastern-polygon/web/pages/[category]/atlas/snezhnyj-pokrov-visota.vue")
  },
  {
    name: "category-atlas-toplivno-energ-resursy",
    path: "/:category()/atlas/toplivno-energ-resursy",
    meta: toplivno_45energ_45resursy5FZXJX8IBuAwCxYtVTR8jxv8_PTPgbDTD6TJz5JzoD8Meta || {},
    component: () => import("/builds/the-eastern-polygon/web/pages/[category]/atlas/toplivno-energ-resursy.vue")
  },
  {
    name: "category-atlas-passazhirskie-perevozki",
    path: "/:category()/atlas/passazhirskie-perevozki",
    meta: passazhirskie_45perevozkioAKUUKGDhxHAw_455MsPrilRyMVxOL9LEx30jJ710NgTsMeta || {},
    component: () => import("/builds/the-eastern-polygon/web/pages/[category]/atlas/passazhirskie-perevozki.vue")
  },
  {
    name: "category-atlas-temperatury-sred-menee8",
    path: "/:category()/atlas/temperatury-sred-menee8",
    meta: temperatury_45sred_45menee8H9XAqV61wJNwhRP_45s9fFY0xef42KmzlrIMMx7BbO8mQMeta || {},
    component: () => import("/builds/the-eastern-polygon/web/pages/[category]/atlas/temperatury-sred-menee8.vue")
  },
  {
    name: "category-atlas-temperatury-sred-vozduha",
    path: "/:category()/atlas/temperatury-sred-vozduha",
    meta: temperatury_45sred_45vozduha552KlBaLcIqatoZechoAtIAo6gOdKQcgfh0s7qCQZ1QMeta || {},
    component: () => import("/builds/the-eastern-polygon/web/pages/[category]/atlas/temperatury-sred-vozduha.vue")
  },
  {
    name: "category-atlas-snezhnyj-pokrov-otlojenia",
    path: "/:category()/atlas/snezhnyj-pokrov-otlojenia",
    meta: snezhnyj_45pokrov_45otlojeniaYY1DDfQZrppPWP8uebHLIm1mjpiiZ03FOvEWEy2C5_450Meta || {},
    component: () => import("/builds/the-eastern-polygon/web/pages/[category]/atlas/snezhnyj-pokrov-otlojenia.vue")
  },
  {
    name: "category-atlas-snezhnyj-pokrov-chislo-dnei",
    path: "/:category()/atlas/snezhnyj-pokrov-chislo-dnei",
    meta: snezhnyj_45pokrov_45chislo_45dnei84lM84UByzD99_yhpRWXO5o6JZy_45Q63tUZZE8yC0Jo4Meta || {},
    component: () => import("/builds/the-eastern-polygon/web/pages/[category]/atlas/snezhnyj-pokrov-chislo-dnei.vue")
  },
  {
    name: "category-atlas-temperatury-max-sred-vozduha",
    path: "/:category()/atlas/temperatury-max-sred-vozduha",
    meta: temperatury_45max_45sred_45vozduhaH6jRF9MDgKwuTaAxzv5aBBorfnc29jwAwpxHof0CZBoMeta || {},
    component: () => import("/builds/the-eastern-polygon/web/pages/[category]/atlas/temperatury-max-sred-vozduha.vue")
  },
  {
    name: "category-atlas-temperatury-min-sred-vozduha",
    path: "/:category()/atlas/temperatury-min-sred-vozduha",
    meta: temperatury_45min_45sred_45vozduhaVXBwPvZtCc9_45yFgPolaNdUg_45Q30QF5bAi0co6mnFr28Meta || {},
    component: () => import("/builds/the-eastern-polygon/web/pages/[category]/atlas/temperatury-min-sred-vozduha.vue")
  },
  {
    name: "category-longreads-parent-parent2",
    path: "/:category()/longreads/:parent()/:parent2()",
    component: () => import("/builds/the-eastern-polygon/web/pages/[category]/longreads/[parent]/[parent2]/index.vue")
  },
  {
    name: "category-longreads-parent-longread-slug",
    path: "/:category()/longreads/:parent()/longread-:slug()",
    component: () => import("/builds/the-eastern-polygon/web/pages/[category]/longreads/[parent]/longread-[slug].vue")
  },
  {
    name: "category-longreads-parent-longread-vokzaly",
    path: "/:category()/longreads/:parent()/longread-vokzaly",
    component: () => import("/builds/the-eastern-polygon/web/pages/[category]/longreads/[parent]/longread-vokzaly.vue")
  },
  {
    name: "category-atlas-prigorodnoe-passazh-soobshchenie",
    path: "/:category()/atlas/prigorodnoe-passazh-soobshchenie",
    meta: prigorodnoe_45passazh_45soobshchenieCYTYJipT58DB1kf1RVxY3vK2o23FOFOFmSxsqmsW9c8Meta || {},
    component: () => import("/builds/the-eastern-polygon/web/pages/[category]/atlas/prigorodnoe-passazh-soobshchenie.vue")
  },
  {
    name: "category-longreads-parent-parent2-longread-slug",
    path: "/:category()/longreads/:parent()/:parent2()/longread-:slug()",
    component: () => import("/builds/the-eastern-polygon/web/pages/[category]/longreads/[parent]/[parent2]/longread-[slug].vue")
  }
]